import React, { useEffect } from 'react'
import { Form, DatePicker, TimePicker, Button, Row, Col, Switch } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'

const AvailabilityItemEdit = ({ item, onSave, onCancel, onDelete, isSaving, timezone }) => {
  const [form] = Form.useForm()

  useEffect(() => {
    // Initialize form with current values (already in the correct timezone)
    form.setFieldsValue({
      date: item.start,
      startTime: item.start,
      endTime: item.end,
      is_active_for_inspection: item.is_active_for_inspection,
    })
  }, [form, item.start, item.end, item.is_active_for_inspection])

  const handleSave = () => {
    form.validateFields().then((values) => {
      const { date, startTime, endTime, is_active_for_inspection } = values

      // Combine date with start time, preserving timezone
      const newStart = date.clone().set({
        hour: startTime.hour(),
        minute: startTime.minute(),
        second: 0,
        millisecond: 0,
      })

      // Combine date with end time, preserving timezone
      const newEnd = date.clone().set({
        hour: endTime.hour(),
        minute: endTime.minute(),
        second: 0,
        millisecond: 0,
      })

      onSave({
        ...item,
        start: newStart,
        end: newEnd,
        is_active_for_inspection: is_active_for_inspection,
      })
    })
  }

  return (
    <Form form={form} layout="inline" style={{ width: '100%' }}>
      <Row gutter={16} style={{ width: '100%' }}>
        <Col span={8}>
          <Form.Item
            name="date"
            label="Date"
            style={{ marginBottom: 0 }}
            rules={[{ required: true, message: 'Date is required' }]}
          >
            <DatePicker format="MMMM D, YYYY" style={{ width: '100%' }} allowClear={false} />
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            name="startTime"
            label="Start Time"
            style={{ marginBottom: 0 }}
            rules={[{ required: true, message: 'Start time is required' }]}
          >
            <TimePicker format="h:mmA" style={{ width: '100%' }} minuteStep={30} showNow={false} />
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            name="endTime"
            label="End Time"
            style={{ marginBottom: 0 }}
            rules={[
              { required: true, message: 'End time is required' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const startTime = getFieldValue('startTime')
                  if (!value || !startTime) {
                    return Promise.resolve()
                  }
                  if (value.isSameOrBefore(startTime)) {
                    return Promise.reject(new Error('End time must be after start time'))
                  }
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <TimePicker format="h:mmA" style={{ width: '100%' }} minuteStep={30} showNow={false} />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Button type="text" danger icon={<DeleteOutlined />} onClick={() => onDelete(item.id)} disabled={isSaving} />
        </Col>
      </Row>
      <Row style={{ marginTop: 12, width: '100%' }}>
        <Col span={12}>
          <Form.Item
            name="is_active_for_inspection"
            label="Active for Inspection"
            style={{ marginBottom: 0 }}
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Button type="primary" onClick={handleSave} loading={isSaving} disabled={isSaving} style={{ marginRight: 8 }}>
            Save
          </Button>
          <Button onClick={onCancel} disabled={isSaving}>
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

export default AvailabilityItemEdit
